import React from "react";
import { User, House, Heart, PlusCircle, MapPin, ArrowSquareOut } from "@phosphor-icons/react";
import PageHeader from "../components/PageHeader";
import EmergencyButton from "../components/EmergencyButton";
import { PROS } from "../data/staticData";

const ICONS = { User, House, Heart, PlusCircle };

export default function Aide() {
  return (
    <div>
      <PageHeader title="Trouver de l'aide" />

      <div className="px-6">
        <p className="text-[14.5px] leading-relaxed text-[#36302B]/70">
          Demander de l'aide est un geste de force. Voici vers qui vous tourner — Renaître vous oriente,
          sans jamais remplacer un professionnel de santé.
        </p>

        <div className="mt-5">
          <EmergencyButton />
        </div>

        <h2 className="font-display mt-7 mb-3 text-xl font-medium text-[#36302B]">
          Les professionnels du post-partum
        </h2>
        <div className="space-y-3">
          {PROS.map((p) => {
            const Icon = ICONS[p.icon] || User;
            return (
              <div
                key={p.title}
                className="flex gap-3 rounded-3xl border border-[#36302B]/6 bg-white p-4 shadow-[0_4px_20px_rgba(54,48,43,0.03)]"
              >
                <div className="flex h-10 w-10 shrink-0 items-center justify-center rounded-2xl bg-[#D3B683]/20">
                  <Icon size={20} color="#B99248" weight="duotone" />
                </div>
                <div>
                  <p className="font-display text-[16px] font-medium text-[#36302B]">{p.title}</p>
                  <p className="mt-1 text-[13.5px] leading-relaxed text-[#36302B]/65">{p.role}</p>
                </div>
              </div>
            );
          })}
        </div>

        <a
          href="https://sante.fr/recherche"
          target="_blank"
          rel="noopener noreferrer"
          data-testid="aide-annuaire"
          className="mt-4 flex items-center gap-3 rounded-3xl bg-[#F2EDE4] p-4"
        >
          <MapPin size={20} color="#C57B67" weight="fill" />
          <div className="flex-1">
            <p className="text-[14px] font-bold text-[#36302B]">Trouver un professionnel près de chez vous</p>
            <p className="text-[12.5px] text-[#36302B]/60">Annuaire officiel santé.fr</p>
          </div>
          <ArrowSquareOut size={18} color="#36302B" className="opacity-40" />
        </a>

        <p className="mt-6 text-center text-[12px] leading-relaxed text-[#36302B]/45">
          Renaître propose une orientation générale vers des annuaires officiels et ne recommande aucun
          professionnel en particulier. Ces informations ne remplacent pas un avis médical.
        </p>
      </div>
    </div>
  );
}
